module.exports = __webpack_public_path__ + "static/media/riparias-life-vertical.86d0a27e.jpg";